<template>
  <div id="app" class="d-flex flex-column min-vh-100">
    <app-loading
      :active="loading"
      :loader="'spinner'"
      :color="'#343a40'"
    ></app-loading>
    <m-header v-if="isOn && !printing" />
    <router-view />
    <m-footer v-if="isOn && routeChat && !printing" />
  </div>
</template>

<script lang="js">
import Header from '@/components/Header.vue'
import Footer from '@/components/_footer.vue'
import auth from '@/services/auth'

export default {
  components: {
    'm-header': Header,
    'm-footer': Footer
  },
  mounted() {
    this.isOn = auth.isAuthenticated()
  },
  computed: {
    isAuth() {
      return auth.isAuthenticated()
    },
    isLoading() {
      return this.$store.getters['utils/isLoading']
    },
    routeChat(){
      return this.$route.name !== 'detail-incident' && this.$route.name !== 'edit-request'
    },
    isClosed(){
      return this.$store.getters['utils/isNav']
    },
    printing(){
      return ['PlaybookPrint', 'RulesDocumentationPrint'].includes(this.$route.name)
    },
  },

  watch: {
    isAuth() {
      this.isOn = auth.isAuthenticated()
    },
    isLoading() {
      this.loading = this.isLoading
    },
    isClosed(){
      this.isOn = this.isClosed
    }
  },

  data() {
    return {
      isOn: false,
      loading:false
    }
  },


}
</script>

<style lang="scss">
@import '~@/assets/scss/app.scss';

#app {
  background-color: #f5f5f6;
}
</style>
